<template>
    <v-expansion-panels v-model="panel" width="100%" :height="height" id="myprovet_filters" class="myprovet-card mx-auto" active-class="myprovet-card mx-auto" style="z-index: 3">
        <v-expansion-panel @click.prevent="onShrinkFilterCard()">
            <v-expansion-panel-header class="py-0 pl-0 pr-5" style="cursor: default !important" disable-icon-rotate>
                <slot name="title" />

                <template v-slot:actions>
                    <!-- <app-dialog :value="isHelpDialogOpen" @input="isHelpDialogOpen = $event" width="70vh" title="Ajuda">
                        <template v-slot:content> </template>

                        <template v-slot:buttons="{}">
                            <v-btn text outlined class="myprovet-btn-cancel" @click="isHelpDialogOpen = false" data-cy="app-dialog-help-close-btn"> Fechar </v-btn>
                        </template>
                    </app-dialog>

                    <v-tooltip bottom open-on-hover content-class="myprovet-tooltip">
                        <template v-slot:activator="{ on, attrs }">
                            <v-icon v-bind="attrs" v-on="on" class="appbar-icon-button-small btn-bg-color-white dark-blue-color mr-1" style="cursor: pointer" data-cy="help-filter-card" @click.stop="isHelpDialogOpen = true"> mdi-help-circle-outline </v-icon>
                        </template>

                        <span>Ajuda</span>
                    </v-tooltip>  -->

                    <slot name="actions"></slot>

                    <v-tooltip bottom open-on-hover content-class="myprovet-tooltip">
                        <template v-slot:activator="{ on, attrs }">
                            <v-icon v-bind="attrs" v-on="on" class="appbar-icon-button-small btn-bg-color-white dark-blue-color mr-0" style="cursor: pointer" data-cy="hide-filter-card" @click.stop="onShrinkFilterCard">
                                {{ shrinkIcon }}
                            </v-icon>
                        </template>

                        <span>{{ tb(shrinkTooltipText) }}</span>
                    </v-tooltip>
                </template>
            </v-expansion-panel-header>

            <v-expansion-panel-content class="no-wrap">
                <slot name="content" />
            </v-expansion-panel-content>
        </v-expansion-panel>
    </v-expansion-panels>
</template>

<script>
export default {
    props: {
        height: '',
        contentIsScrollable: false,
    },

    data: () => ({
        panel: 0,
        shrinkIcon: 'mdi-chevron-down',
        shrinkTooltipText: 'Esconder Filtros',
        isFilterCardExpanded: true,

        isHelpDialogOpen: false,
    }),

    watch: {
        panel: {
            handler: function () {
                if (this.panel === undefined) {
                    this.shrinkIcon = 'mdi-chevron-down';
                    this.shrinkTooltipText = 'Mostrar Filtros';
                } else {
                    this.shrinkIcon = 'mdi-chevron-up';
                    this.shrinkTooltipText = 'Esconder Filtros';
                }

                this.panel === undefined ? (this.isFilterCardExpanded = false) : (this.isFilterCardExpanded = true);
            },
            immediate: true,
        },

        isFilterCardExpanded: {
            handler: function () {
                this.$emit('expanded', this.isFilterCardExpanded);
            },
            immediate: true,
        },
    },

    methods: {
        onShrinkFilterCard() {
            const curr = this.panel;
            this.panel = curr === undefined ? 0 : undefined;
        },
    },
};
</script>

<style scoped>
.no-wrap :first-child {
    padding-bottom: 0px;
}
</style>
